<template>
  <v-form ref="form" v-model="formComplete" :value="formValid">
    <v-container class="customerContainer">
      <div class="customerText">
        <div class="customerTextTitle">
          {{ title }}
        </div>
        <div class="customerTextInfo noMargin">
          {{ info }}
        </div>
      </div>
      <v-layout row wrap class="form">
        <v-flex x12>
          <v-layout row wrap>
            <v-flex xs12 sm6 md6 lg6>
              <v-text-field
                class="customerInputField"
                :class="{
                  'mr-2': $vuetify.breakpoint.smAndUp,
                }"
                :value="firstName"
                label="First Name"
                name="fname"
                @input="$emit('update:firstName', $event)"
                :rules="[rules.required]"
                outline
                autocomplete="given-name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md6 lg6>
              <v-text-field
                class="customerInputField"
                :value="lastName"
                label="Last Name"
                name="lname"
                @input="$emit('update:lastName', $event)"
                :rules="[rules.required]"
                outline
                autocomplete="family-name"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12 sm12 md6>
              <v-text-field
                class="customerInputField"
                :class="{
                  'mr-2': $vuetify.breakpoint.mdAndUp,
                }"
                :value="email"
                label="Email"
                name="email"
                @input="$emit('update:email', $event)"
                :rules="[emailValidation]"
                outline
                autocomplete="email"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    info: {
      type: String,
      default: '',
    },
    firstName: {
      type: String,
      default: '',
    },
    lastName: {
      type: String,
      default: '',
    },
    email: {
      type: String,
      default: '',
    },
    customerCompleted: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    formValid: false,
    rules: {
      required: value => !!value || 'Required.',
    },
    formComplete: false,
  }),
  methods: {
    emailValidation(email) {
      if (!this.$$validateEmail(email)) {
        return 'Please enter a valid email.';
      }

      return true;
    },
  },
  computed: {
    isFormCompleted() {
      let value = false;
      if (
        this.firstName
        && this.lastName
        && this.email
      ) {
        value = true;
      }
      return value;
    },
  },
  watch: {
    formComplete(isComplete) {
      if (isComplete && this.isFormCompleted) {
        const isValid = this.$refs.form.validate();
        this.$emit('update:customerCompleted', isValid);
      } else {
        this.$emit('update:customerCompleted', false);
      }
    },
  },
};
</script>

<style>
.customerContainer {
  padding-bottom: 0px !important;
  padding-top: 25px;
}
.customerTextTitle {
  font-family: Gotham;
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 5px;
  color: #333333;
  padding-top: 30px;
}

.customerTextInfo {
  font-family: Gotham;
  font-size: 16px;
  text-align: left;
  color: #000000;
  margin-bottom: 10px;
}

.customerInputField {
  font-family: Gotham;
  font-size: 16px;
  color: #999999;
}

.noMargin {
  margin: 0px !important;
}

 /* Extra large Break Point */
@media screen and (min-width: 1904px) {
}

 /* Tablet Break Point */
@media screen and (max-width: 1264px) {
}

 /* Mid Phone to Tablet Break Point */
@media screen and (min-width: 767px) and (max-width: 959px) {
}

/* Mobile Break Point */
@media screen and (max-width: 767px) {
}
</style>
